import { NgModule } from "@angular/core";
import { CoreModule } from "../../../core/core.module";
import { DirectivesModule } from "../../directives/directives.module";
import { PipesModule } from "../../pipes/pipes.module";
import { DynamicActionTemplateComponent } from "../dynamic-action-template/dynamic-action-template.component";
import { GenericModalComponent } from "./generic-modal.component";

@NgModule({
  declarations: [GenericModalComponent, DynamicActionTemplateComponent],
  imports: [CoreModule, DirectivesModule, PipesModule],
  exports: [GenericModalComponent, DynamicActionTemplateComponent],
})
export class GenericModalModule {}
